export enum GoalCategoryType {
    DRAFT,
    ACTIVE_FOR_THIS_COMMITMENT,
    ACTIVE_FOR_OTHER_COMMITMENT,
    RECENTLY_CLOSED,
    DISPUTED,
}
